/**
 * A set of utilities for dealing with the old AngularJS manager
 * running side-by-side with the newer React App
 */

export const angularRouterHost = () => {
  return "http://" + window.location.hostname + ":80/#/";
};
